export const designFilters = [
    {
        "filterName": null,
        "displayName": "None",
        "src": "uploads/filters/0_Original.jpg"
    },
    {
        "filterName": "citrine",
        "displayName": "Citrine",
        "src": "uploads/filters/1_Citrine.jpg"
    },
    {
        "filterName": "raspberry",
        "displayName": "Raspberry",
        "src": "uploads/filters/2_Raspberry.jpg"
    },
    {
        "filterName": "gaspeite",
        "displayName": "Gaspeite",
        "src": "uploads/filters/3_Gaspeite.jpg"
    },
    {
        "filterName": "lapis-lazuli",
        "displayName": "Lapis Lazuli",
        "src": "uploads/filters/4_Lapis Lazuli.jpg"
    },
    {
        "filterName": "kyanite",
        "displayName": "Kyanite",
        "src": "uploads/filters/5_Kyanite.jpg"
    },
    {
        "filterName": "morganite",
        "displayName": "Morganite",
        "src": "uploads/filters/6_Morganite.jpg"
    },
    {
        "filterName": "jade",
        "displayName": "Jade",
        "src": "uploads/filters/7_Jade.jpg"
    },
    {
        "filterName": "brandberg",
        "displayName": "Brandberg",
        "src": "uploads/filters/8_Brandberg.jpg"
    },
    {
        "filterName": "stilbite",
        "displayName": "Stilbite",
        "src": "uploads/filters/9_Stilbite.jpg"
    },
    {
        "filterName": "sunstone",
        "displayName": "Sunstone",
        "src": "uploads/filters/10_Sunstone.jpg"
    },
    {
        "filterName": "ametrine",
        "displayName": "Ametrine",
        "src": "uploads/filters/11_Ametrine.jpg"
    },
    {
        "filterName": "tugtupite",
        "displayName": "Tugtupite",
        "src": "uploads/filters/12_Tugtupite.jpg"
    },
    {
        "filterName": "amber",
        "displayName": "Amber",
        "src": "uploads/filters/13_Amber.jpg"
    },
    {
        "filterName": "crocoite",
        "displayName": "Crocoite",
        "src": "uploads/filters/14_Crocoite.jpg"
    },
    {
        "filterName": "aegirine",
        "displayName": "Aegirine",
        "src": "uploads/filters/15_Aegirine.jpg"
    },
    {
        "filterName": "atacamite",
        "displayName": "Atacamite",
        "src": "uploads/filters/16_Atacamite.jpg"
    },
    {
        "filterName": "azurite",
        "displayName": "Azurite",
        "src": "uploads/filters/17_Azurite.jpg"
    },
    {
        "filterName": "chrysoprase",
        "displayName": "Chrysoprase",
        "src": "uploads/filters/18_Chrysoprase.jpg"
    },
    {
        "filterName": "limonite",
        "displayName": "Limonite",
        "src": "uploads/filters/19_Limonite.jpg"
    },
    {
        "filterName": "peridot",
        "displayName": "Peridot",
        "src": "uploads/filters/20_Peridot.jpg"
    }
];